module.exports = __webpack_public_path__ + "fonts/ralewaybold.54de3cd.ttf";